export default __webpack_public_path__ + "static/media/Diekkes.be624054.png";